import React from 'react';

import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {TagSchemaContainableType} from 'constants/RegistryConstants';
import TagSchemaSettingsDropdown, {
  TagSchemaSettingsDropdownOption,
} from 'settings/registry/TagSchemaSettingsDropdown';

export interface TagSchemaSampleTypeConfigurationProps {
  isContainable?: boolean;
  isWritable?: boolean;
  onChange: (isContainable: boolean, containableType?: TagSchemaContainableType) => void;
  folderItemType: string;
}

class TagSchemaSampleTypeConfiguration extends React.Component<TagSchemaSampleTypeConfigurationProps> {
  _getConfigurationText = (): string => {
    if (this.props.isContainable) {
      return 'Entity';
    } else {
      return 'None';
    }
  };

  _handleChange = (newIsContainable: boolean, newContainableType: TagSchemaContainableType): void => {
    this.props.onChange(newIsContainable, newContainableType);
  };

  _handleSetContainable = (): void => {
    this._handleChange(true, TagSchemaContainableType.ENTITY);
  };

  _handleCreateOrRestoreBatchSchema = (): void => {
    this._handleChange(false, TagSchemaContainableType.BATCH);
  };

  _handleRemoveSampleSetting = (): void => {
    this._handleChange(false, TagSchemaContainableType.NONE);
  };

  _getContainableTypeConfigurationOptions = (): Array<TagSchemaSettingsDropdownOption> => {
    const options = [];
    if (isFeatureEnabled({feature: InventoryFeature.INVENTORY_ADMIN})) {
      options.push({
        name: 'Entity',
        handleOnSelect: this._handleSetContainable,
        description: 'Entity can be transferred into containers.',
      });
    }
    options.push({
      name: 'None',
      handleOnSelect: this._handleRemoveSampleSetting,
      description: 'Entity cannot be transferred into containers.',
    });
    return options;
  };

  render(): JSX.Element | null {
    const isEnabled = this._getContainableTypeConfigurationOptions().length > 1;
    if (!isEnabled) {
      return null;
    }
    return (
      <TagSchemaSettingsDropdown
        displayText={this._getConfigurationText()}
        isWritable={this.props.isWritable}
        options={this._getContainableTypeConfigurationOptions()}
        label="Containable Type"
      />
    );
  }
}

export default TagSchemaSampleTypeConfiguration;
